import React from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import PropTypes from "prop-types";
import styled from "styled-components";

import { useAppState } from "../../../contexts/ApplicationStateProvider";
import { useStores } from "../../../contexts/StoreContext";

const StyledNavigationColumn = styled.div`
  margin-right: ${({ columnGap }) => columnGap || "50px"};
`;

function MultiColumn(props) {
  const { navigationLinks, navigationItemClassName = "mb-4" } = props;

  const { footerStore } = useStores();
  const { additionalConfiguration, columnConfig = [] } = footerStore;
  const { isMobile } = useAppState();

  if (isEmpty(navigationLinks) || isEmpty(columnConfig)) {
    return null;
  }

  const listItemClassName = classNames(
    "navigationLink text-nowrap",
    navigationItemClassName
  );

  let lastIndex = 0;

  const multiColumnClassName = classNames("d-flex list-unstyled", {
    "justify-content-start ps-5": isMobile,
  });

  return (
    <div className={multiColumnClassName}>
      {columnConfig.map(({ columnName, capacity }, index) => {
        const startIndex = lastIndex;
        const endIndex = lastIndex + capacity;
        lastIndex += capacity;

        const isLastColumn = index === columnConfig.length - 1;

        const columnLinks = navigationLinks.slice(
          startIndex,
          isLastColumn ? navigationLinks.length : endIndex
        );

        return (
          <StyledNavigationColumn
            key={columnName}
            columnGap={
              additionalConfiguration?.footerNavigation?.columnGap || {}
            }
            data-testid="column"
          >
            <h5>{columnName}</h5>
            <ul className="list-unstyled">
              {columnLinks.map((column) => {
                const href = column.path
                  ? `/${column.path}`
                  : column.externalPath;
                return (
                  <li key={`${column.title}`} className={listItemClassName}>
                    <a href={href}>{column.title}</a>
                  </li>
                );
              })}
            </ul>
          </StyledNavigationColumn>
        );
      })}
    </div>
  );
}

export default MultiColumn;

MultiColumn.propTypes = {
  navigationItemClassName: PropTypes.string,
  navigationLinks: PropTypes.arrayOf(
    PropTypes.shape({ externalPath: PropTypes.string, title: PropTypes.string })
  ).isRequired,
};

MultiColumn.defaultProps = {
  navigationItemClassName: "mb-4",
};
